<template>
  <div class="ai-alarm-detail">
    <!-- 视频AI事件报警设置 -->
    <div class="title-box">AI报警列表内容</div>
    <!-- 查询条件 -->

    <el-form
      id="aiAlarmDetailForm"
      :inline="true"
      :model="formData"
      style="border-radius: 3px; margin-bottom: 10px; box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1)"
      class="demo-form-inline"
    >
      <el-row>
        <el-form-item prop="factoryId">
          <el-select
            v-model="formData.factoryId"
            filterable
            placeholder="选择工厂"
            clearable
            @change="getWorkshopByFactory"
          >
            <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="workshopId">
          <el-select
            v-model="formData.workshopId"
            filterable
            clearable
            placeholder="选择车间"
            @change="getSceneByWorkshop"
          >
            <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sceneId">
          <el-select v-model="formData.sceneId" placeholder="选择场景" filterable clearable>
            <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      :style="{ height: tableHeight + 'px', width: '100%', 'border-radius': '3px' }"
      :height="tableHeight"
      class="custom-table-header"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
      <el-table-column prop="factoryName" min-width="120" label="工厂" align="center"></el-table-column>
      <el-table-column prop="workshopName" min-width="120" label="车间" align="center"></el-table-column>
      <el-table-column prop="sceneName" min-width="120" label="场景" align="center"></el-table-column>
      <el-table-column prop="deviceNumbs" min-width="120" label="事件编号" align="center"></el-table-column>
      <el-table-column
        prop="alarmEventType"
        min-width="120"
        label="事件类型"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column prop="alarmStartTime" min-width="120" label="事件开始时间" align="center"></el-table-column>
      <el-table-column prop="alarmDurationStr" min-width="120" label="事件持续时长" align="center"></el-table-column>
      <el-table-column prop="alarmEndTime" min-width="120" label="事件结束时间" align="center"></el-table-column>
      <el-table-column prop="alarmAlertCategory" min-width="120" label="报警类别" align="center"></el-table-column>
      <el-table-column prop="eventTypeName" min-width="120" label="事件视频" align="center"></el-table-column>
      <el-table-column
        prop="pushUserCount"
        min-width="120"
        label="报警推送人数"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column label="复核人" min-width="120" prop="reviewPersonName" align="center"></el-table-column>
      <el-table-column prop="pushTimeRangeStr" min-width="120" label="复核时间" align="center"></el-table-column>
      <el-table-column label="处理人" min-width="120" prop="handleUserName" align="center"></el-table-column>
      <el-table-column label="处理时间" min-width="120" prop="handleTime" align="center"></el-table-column>
      <el-table-column label="处理备注" min-width="120" prop="handleRemark" align="center"></el-table-column>
      <el-table-column label="操作" fixed="right" width="100" align="center">
        <template slot-scope="scope">
          <el-button style="color: #3083fb !important" @click="handlerFn(scope.row)" type="text" size="small"
            >处理</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="block" style="background: #fff; text-align: center; padding: 20px 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="处理"
      :visible.sync="dialogVisible"
      width="616px"
      class="custom-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="50px">
        <el-form-item label="备注" prop="handleRemark">
          <el-input v-model="form.handleRemark" type="textarea" maxlength="500"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subMitHandler">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';
import api from '@/utils/api';
import { Message, MessageBox } from 'element-ui';

export default {
  data() {
    return {
      // 查询条件
      formData: {
        factoryId: '',
        workshopId: '',
        sceneId: ''
      },
      form: {
        handleRemark: '',
        alarmTypeCode: '',
        id: ''
      },
      //工厂数据
      factoryOptions: [],
      // 车间数据
      workshopOptions: [],
      sceneOptions: [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      tableHeight: 650,
      // 表格数据
      tableData: [],
      loading: false,
      dialogVisible: false,
      rules: {
        handleRemark: [{ required: true, message: '请输入备注', trigger: ['blur', 'change'] }]
      }
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.getList();
    this.getFactoryByCustomer();
  },
  methods: {
    // 监听窗口缩放
    handleResize() {
      // 当窗口大小变化时，这个函数会被调用
      const height = window.innerHeight;
      // 你可以在这里添加你的处理代码
      let dom = document.getElementById('aiAlarmDetailForm');
      let formH = 70; //一行时高度为70
      if (dom) {
        formH = dom.offsetHeight;
      }
      this.tableHeight = height - 191 - formH; //表单的高度会变化

      if (this.lineChart) {
        this.lineChart.resize();
      }
    },
    handlerFn() {
      this.dialogVisible = true;
    },
    // 查询
    onSubmit() {
      this.getList();
    },
    // 重置
    onReset() {
      this.formData = {
        factoryId: '',
        workshopId: '',
        sceneId: ''
      };
      this.getList();
    },
    // 处理
    handlerFn(item) {
      this.dialogVisible = true;

      this.form.handleRemark = item?.handleRemark || '';
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.form.id = item.id;
      this.form.alarmTypeCode = 1;
    },
    subMitHandler() {
      const params = {
        ...this.form
      };
      request
        .post(api.alarmDetail.handleAlarm, params)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('处理成功');
            this.dialogVisible = false;
            this.getList();
          } else {
            this.$message.error('处理失败');
          }
        })
        .catch((err) => {});
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store
        .dispatch('workshop/getFactoryByCustomer')
        .then((result) => {
          if (result.code === 200 && result.data.length) {
            this.factoryOptions = result.data;
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store
        .dispatch('scene/getWorkshopByFactory', { factoryId: this.formData.factoryId })
        .then((result) => {
          this.formData.workshopId = '';
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.workshopOptions = result.data;
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 根据车间查询场景
    getSceneByWorkshop() {
      this.$store
        .dispatch('monitorData/getSceneByWorkshop', { workshopId: this.formData.workshopId })
        .then((result) => {
          this.formData.sceneId = null;
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.sceneOptions = result.data;
          } else {
            this.sceneOptions = [];
          }
        })
        .catch((err) => {
          this.sceneOptions = [];
        });
    },
    refreshTable() {
      this.getList();
    },
    getList() {
      const params = {
        factoryId: this.formData.factoryId,
        workshopId: this.formData.workshopId,
        sceneId: this.formData.sceneId,
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      this.loading = true;
      request
        .get(`${api.alarmDetail.getAiEdgeMachineList}`, {
          params: params
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = (res.rows || []).map((item) => {
              return {
                id: item.id,
                factoryId: item?.factoryId,
                workshopId: item?.workshopId,
                sceneId: item?.sceneId,
                alarmAiContentId: item?.id,
                deviceNumbs: item?.deviceNumbs,
                alarmEventType: item?.alarmEventType,
                alarmAlertCategory: item?.alarmAlertCategory,
                alarmStartTime: item?.alarmStartTime,
                alarmDurationStr: item?.alarmDurationStr,
                alarmEndTime: item?.alarmEndTime,
                pushUserCount: item?.pushUserCount, // 这里修复了拼写错误
                contactUserIdList: item?.alarmPushSetting?.contactUserIdList.join(';'),
                pushTimeRangeStr: item?.alarmPushSetting?.pushTimeRangeStr,
                factoryName: item.factoryName,
                workshopName: item.workshopName,
                sceneName: item.sceneName,
                handleUserName: item?.handleUserName,
                handleTime: item?.handleTime,
                handleRemark: item?.handleRemark,
                reviewPersonName: item?.reviewPersonName
              };
            });
            this.total = res.total;
            this.loading = false;
            console.log(this.tableData);
          } else {
            this.tableData = [];
            this.total = 0;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.tableData = [];
          this.total = 0;
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.title-box {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  padding: 27px 0 15px;
  line-height: 16px;
}
.params-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
// 表头背景色
::v-deep .custom-table-header th {
  background-color: #ebeef5 !important;
}
// 表格字体大小
.el-table {
  font-size: 12px;
}
// 表单底部边界线
.el-table::before {
  height: 0px;
}
// 表格字体
::v-deep .el-table thead {
  color: #606266;
}
// 表格内边距
::v-deep .el-table .el-table__cell {
  padding: 8px 0;
}
// 表单底部margin
.el-form-item {
  margin-bottom: 0;
}
// 当前页码样式
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff9f07;
}
// 页面hover样式
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff9f07;
}
// .el-button{
//     font-size: 12px;
// }
::v-deep .el-form-item__label {
  font-size: 12px;
}
::v-deep .el-table__body-wrapper {
  height: 100%;
  overflow-y: auto;
}
.tool-icon {
  width: 28px;
  height: 32px;
  cursor: pointer;
  background: #c7c7c7;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  border-radius: 4px;
  margin-left: 5px;
}
.select-icon {
  background: #3083fb;
}
</style>
